import { css as cn } from '@emotion/css';

import { cssClass } from './cssClass';
import { theme } from './theme';

export const cssUtil = {
  // CSS ancestor selectors (emotion styled template literals)
  isDarkTheme: `.${cssClass.darkTheme} &`,
  isReducedMotion: `.${cssClass.reducedMotion} &`,

  // Responsive breakpoints
  viewport: {
    small: '0',
    medium: '640px',
    large: '1280px',
  },

  // Theme-derived classes
  color: {
    light: cn`
      color: ${theme.color.text_light};
    `,
  },
};
